module.exports = __webpack_public_path__ + "static/media/5543b8b4-c014-4f27-8574-a4f237bef11b_1.3d0dbe3be6d70c8bc8c05b9321db5d94.e5b06d70.jpeg";